<template>
  <b-collapse id="nav-collapse" is-nav>
    <slot></slot>
  </b-collapse>
</template>

<script>
export default {};
</script>